// eslint-disable-next-line no-unused-vars
import { Paginator } from '@/hooks/resource/use-paginator'

/**
 *
 * @param {String} title
 * @param {String} locale
 * @param {Paginator} paginator
 */
export default function(title, locale, paginator) {
  const cp = paginator.result.currentPage
  const pageText = locale === 'en' ? 'Page' : 'Sayfa'
  if (cp > 1) {
    return `${title} - ${pageText} ${cp}`
  }
  return title
}
